<template>
    <span>
        {{ minutes }}:{{ seconds }}
    </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
        default: 0
      },
      start: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        timer: null,
        totalTime: 0
      };
    },
    mounted () {
      this.totalTime = this.value;
      if (this.start) {
        this.startTimer();
      }
    },
    beforeDestroy () {
      if (this.timer) {
        this.stopTimer();
      }
    },
    methods: {
      startTimer () {
        this.timer = setInterval(() => this.count(), 1000);
      },
      stopTimer () {
        clearInterval(this.timer);
        this.timer = null;
        this.resetButton = true;
      },
      resetTimer () {
        this.totalTime = 25 * 60;
        clearInterval(this.timer);
        this.timer = null;
      },
      padTime (time) {
        return (time < 10 ? '0' : '') + time;
      },
      count () {
        this.totalTime++;
        this.$emit('input', this.totalTime);
      }
    },
    computed: {
      minutes: function () {
        const minutes = Math.floor(this.totalTime / 60);
        return this.padTime(minutes);
      },
      seconds: function () {
        const seconds = this.totalTime - this.minutes * 60;
        return this.padTime(seconds);
      }
    }
  };
</script>
